export default "__VITE_ASSET__CfNOFwVI__"